export default {
  loading: true,
  allAchievements: {},
  singleAchievement: {},
  companyTeams: {},
  totalAchievements: 50,
  selectedScore: null
}
